export default {
  'editorial-staff': 'Notre rédaction',
  'published-on': 'Publié le',
  'read-articles': 'Lire ses articles',
  'about-author': "À propos de l'auteur",
}
